<template>
    <section class="add-purchase-item">
        <div class="purchase-input" v-if="isPublic && available">
            <div class="quantity">
                <div class="qty-input">
                    <b-button @click="decrementItem(item)" variant="light">-</b-button>
                    <b-input v-model="internalQty" :min="1" :max="item.remaining_qty"></b-input>
                    <b-button @click="incrementItem(item)" variant="light">+</b-button>
                </div>
            </div>
            <form class="form" :action="action()" method="post" @submit.prevent="continueToConfirm" ref="form">
                <input type="hidden" name="ids" :value="payload"/>
                <b-button
                    variant="primary"
                    size="sm"
                    type="submit"
                    block="block"
                    :disabled="!validProduct"
                >
                    <div class="add-to-cart">
                        <div>
                            <span v-if="item.purchased_qty >= item.qty">{{
                                    $t('wishlist.alreadyPurchased', item)
                                }}</span>
                            <span v-else>{{ $t('wishlist.addToCart') }}</span>
                        </div>
                        <AddToCartIcon></AddToCartIcon>
                    </div>
                </b-button>
                <div class="quantity__purchased-amount">
                    <span v-if="item.purchased_qty > 0">{{ $t('wishlist.purchasedAmount', item) }}</span>
                    <span v-else>{{ $t('wishlist.wishedAmount', item) }}</span>
                </div>
            </form>
            <b-modal
                v-model="showConfirmation"
                :title="$t('wishlist.confirmTitle')"
                @ok="submitForm"
                :ok-title="$t('wishlist.confirmPublicWishlistPurchaseOkButton')"
                :cancel-title="$t('wishlist.confirmPublicWishlistCancelButton')"
            >
                {{ $t('wishlist.confirmPublicWishlistPurchaseModalText') }}
            </b-modal>
        </div>
    </section>
</template>
<script>
import { useWishlistStore } from '@stores/Wishlist';
import AddToCartIcon from '@components/Icons/AddToCartIcon.vue';
import { useAppStore } from '@stores/App';

export default {
    components: { AddToCartIcon },
    props: {
        wishlist: null,
        item: {},
        isPublic: {
            type: Boolean,
            default() {
                return false;
            }
        },
    },
    data() {
        let qty = 0;

        if (this.wishlist.type === 'standard') {
            qty = this.item.qty;
        } else {
            qty = this.item.remaining_qty ? 1 : 0;
        }

        return {
            internalQty: qty,
            showConfirmation: false,
        };
    },
    computed: {
        available() {
            return this.item?.product?.available;
        },
        validProduct() {
            return !!this.item?.product?.id;
        },
        payload() {
            return JSON.stringify([ {
                id: this.item?.product?.id,
                qty: this.internalQty,
            } ]);
        },
    },
    methods: {
        continueToConfirm() {
            if (this.wishlist.type === 'standard') {
                this.submitForm();
            } else {
                this.showConfirmation = true;
            }
        },
        async submitForm() {
            const store = useWishlistStore();
            const response = await store.addPublicPurchaseItem(
                this.wishlist.uuid,
                this.item.product_id,
                this.internalQty,
            );

            this.$emit('update:items', response.data.items);
            this.$refs.form.submit();
        },
        action() {
            const app = useAppStore();
            return app.formatLink('api/checkout/add-to-cart');
        },
        decrementItem() {
            if (this.internalQty > 1) {
                this.internalQty = parseInt(this.internalQty) - 1;
            }
        },
        incrementItem() {
            this.internalQty = parseInt(this.internalQty) + 1;
        },
    },
};
</script>
<style lang="scss" scoped>

::v-deep(thead) {
    display: none !important;
}

.form {
    width: 100%;
    min-width: 200px;
}

.add-to-cart {
    display: grid;
    text-transform: uppercase;
    grid-template-columns: max-content min-content;
    gap: 8px;
    justify-content: center;
    align-items: center;
}

.quantity__purchased-amount {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    margin-bottom: 0.25rem;
    margin-top: 0.25rem;
}

.qty-input {
    display: grid;
    grid-template-columns: 48px 48px 48px;

    ::v-deep(.btn) {
        position: relative;
        z-index: 1;
        width: 48px !important;
        height: 40px !important;
        padding: 0 !important;
        background: #f3f3f5 !important;
    }

    ::v-deep(input) {
        position: relative;
        z-index: 2;
        text-align: center;
        width: 100% !important;
        height: 40px !important;
        padding: 0 !important;
        background: #f3f3f5 !important;
        border-color: #f3f3f5 !important;
    }
}

.purchase-input {
    display: grid;
    grid-template-columns: 145px 1fr;
    width: 100%;

    ::v-deep(.btn) {
        position: relative;
        z-index: 1;
        height: 40px !important;
        padding: 0 1rem !important;
        width: 100%;
    }

    ::v-deep(input) {
        position: relative;
        z-index: 2;
        text-align: center;
        width: 100% !important;
        height: 40px !important;
        padding: 0 !important;
        background: #f3f3f5 !important;
        border-color: #f3f3f5 !important;
    }
}
</style>
